import { observatoryMetadata } from "../config";
import { changeURLSearchParam } from "../urls";
import { setCurrentObservatory, getCurrentObservatoryName } from "../utils";

/**
 * Create the dropdown with observatory names
 */
export function addObservatoriesToSelector() {
  // Adding Observatories
  const observatorySelectorList = document.querySelector(
    "#observatorySelectorList"
  );

  for (const [key, value] of Object.entries(observatoryMetadata)) {
    const a = document.createElement("button");
    a.innerText = key;
    a.classList.add("dropdown-item");
    a.value = key;
    const li = document.createElement("li");
    li.appendChild(a);

    observatorySelectorList.appendChild(li);

    // Add listener for selecting observatory from dropdown
    a.addEventListener("click", setCurrentObservatory);
  }
}

/**
 * Set the observatory name in the title area
 */
export function updateObservatoryTitle() {
  const observatoryName = getCurrentObservatoryName();
  const observatoryText = document.querySelector(".observatory-title-text");
  observatoryText.textContent = "GJW-" + observatoryName;
  changeURLSearchParam("obs", observatoryName);
}
